import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class ResourcesTabsIndexComponent extends Component {
  @service router;
  @service intl;
  @service betaToggle;

  get tabs() {
    return [
      {
        label: this.intl.t('people.title', { num: 2 }),
        route: 'resources.people.active',
        key: 'people',
      },
    ];
  }

  @action
  isActive(tab) {
    return this.router.currentRouteName?.includes(tab.key);
  }
}
